import { IS_SHOW_COLORS_EDIT_TOOLTIP_LOCALSTORAGE } from '../types';

export const getShowColorsTooltipEditLocalStorage = (
): boolean => {
    const data = localStorage.getItem(IS_SHOW_COLORS_EDIT_TOOLTIP_LOCALSTORAGE);
    const isHideColorsTooltipLocalStorage: boolean = data ? JSON.parse(data) : true;
    return isHideColorsTooltipLocalStorage;
}
